<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="center"><img alt="" src="OEBPS/images/iv-1.png"/></p>
<p class="para2">The spirit of ‘Katie King’, photographed y Sir William Crookes in 1874. through the mediumship of Florrie Cook. The figure is just emerging from the cabinet. Dr. Gully of Malvern is in the foreground.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm2.vue?c1060d5c